<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogoProrrogar" persistent :max-width="Modal.Confirmacao.larguraMaxima">
            <v-list-tile-title class="pl-0 ml-0" slot="activator">
                <v-icon class="material-icons mr-2" small>
                    more_time
                </v-icon>
                Prorrogar
            </v-list-tile-title>

            <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
                <v-card-title class="primary modal-title" primary-title>
                    Prorrogar Compra
                </v-card-title>
                <v-card-text class="pb-0 az-form-content">

                    <v-flex xs12 sm12 d-flex class="data-hora-atual">
                    <div class="az-text mb-3">
                        <label v-show="exibirFimEnvioPropostasELances===true">Data/Hora Fim Envio de Propostas Atual:</label>
                        <label v-show="!exibirFimEnvioPropostasELances">Data/Hora Encerramento Atual:</label>
                        <p>{{dataAtual | az-date(humanizarFormatoDataHora(dataAtual))}}</p>
                    </div>
                    </v-flex>

                    <v-flex xs12 sm8 d-flex class="data-hora-nova">
                        <az-date-simple date-time v-model="dataHoraAtualizada"
                                        :label="exibirFimEnvioPropostasELances ? 'Nova Data/Hora Fim Envio de Propostas' :'Nova Data/Hora de Encerramento'"
                                        name-date="Nova Data"
                                        name-hour="Nova Data"
                                        :min-date="dataMinima"
                                        placeholderDate="__/__/____"
                                        placeholderHour="__:__"
                                        :is-required="mostrarDialogoProrrogar" class="required-field"/>
                    </v-flex>

                    <v-flex xs12 sm12 d-flex class="motivo">
                    <v-textarea v-model="motivo"
                                class="required-field"
                                :error-messages="errors.collect('Motivo Prorrogar')"
                                v-validate="mostrarDialogoProrrogar?'required': ''"
                                :name="'Motivo Prorrogar'"
                                label="Motivo"
                                placeholder="Digite aqui o motivo"
                                rows="3"
                                maxlength="1000"
                                :counter="1000"/>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="px-3 py-2">
                    <v-btn color="botao-cancelar-color" flat outline @click="mostrarDialogoProrrogar = false"> Fechar </v-btn>
                    <v-spacer/>
                    <v-btn color="primary" depressed @click="confirmarProrrogacao"> Confirmar </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-list-tile>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'AcoesProrrogar',
    props: ['exibirFimEnvioPropostasELances', 'dadosGerais'],
    data() {
        return {
            motivo: null,
            mostrarDialogoProrrogar: false,
            dataHoraAtualizada: null,
            Modal
        }
    },
    computed:{
        dataMinima(){
            if(this.exibirFimEnvioPropostasELances===true){
                return this.moment(this.dadosGerais.dataHoraFimEnvioPropostas)
                    .subtract(1, 'days').format('YYYY-MM-DDTHH:mm:ss')
            }
            return this.moment(this.dadosGerais.dataHoraEncerramento)
                .subtract(1, 'days').format('YYYY-MM-DDTHH:mm:ss')
        },
        dataAtual(){
            if(this.exibirFimEnvioPropostasELances===true){
                return this.dadosGerais.dataHoraFimEnvioPropostas
            }
            return this.dadosGerais.dataHoraEncerramento
        }
    },
    methods:{
        async confirmarProrrogacao(){
            await this.validarCampos()
            this.mostrarDialogoProrrogar = false
            this.$emit('confirmarProrrogacao',
                {
                    compraDiretaId: this.dadosGerais.id,
                    motivo: this.motivo,
                    dataHoraAtualizada: this.dataHoraAtualizada
                })
        },
        async validarCampos(){
            return this.$nextTick().then(async () => {
                const estaValidado = await this.$validator.validateAll()
                if (!estaValidado) {
                    throw new Error('Preencha todos os campos obrigatórios.')
                }
            })
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border var(--v-primary-base)
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important

    .acoes
        padding 20px 0 !important

    .painel-item
        box-shadow none
        border-top 1px solid rgba(0, 0, 0, .12)

    .painel-titulo
        color #777
        text-align right
</style>
